/**
 * Quantitative plan limits (seats, Google locations).
 * Mirror of backend `plan_limits.py` / assets/data/plan-limits.json.
 */

export const PLAN_LIMITS = {
  basic: { maxSeats: 2, maxGoogleLocations: 1 },
  professional: { maxSeats: 4, maxGoogleLocations: 3 },
  premium: { maxSeats: 6, maxGoogleLocations: 10 },
};

const DEFAULT_LIMITS = PLAN_LIMITS.basic;

export function normalizePlanKey(plan) {
  const key = String(plan || "")
    .trim()
    .toLowerCase();
  if (key === "professional" || key === "premium" || key === "basic") return key;
  return "basic";
}

export function getPlanLimits(plan) {
  const key = normalizePlanKey(plan);
  const limits = PLAN_LIMITS[key] || DEFAULT_LIMITS;
  return {
    maxSeats: Number(limits.maxSeats),
    maxGoogleLocations: Number(limits.maxGoogleLocations),
  };
}

export function maxSeatsForPlan(plan) {
  return getPlanLimits(plan).maxSeats;
}

export function maxGoogleLocationsForPlan(plan) {
  return getPlanLimits(plan).maxGoogleLocations;
}

export function getCurrentPlanLimits() {
  const plan =
    typeof window !== "undefined" && window.PlanControl?.getCurrentPlan
      ? window.PlanControl.getCurrentPlan()
      : "basic";
  return getPlanLimits(plan);
}

if (typeof window !== "undefined") {
  window.PlanLimits = {
    PLAN_LIMITS,
    getPlanLimits,
    maxSeatsForPlan,
    maxGoogleLocationsForPlan,
    getCurrentPlanLimits,
    normalizePlanKey,
  };
}
